import * as api from '../../services/courier'

export const FETCH_COURIER= 'FETCH_COURIER';



export const fetchCourier = (userId,courierNo) => ({
    type: FETCH_COURIER,
    payload: {
        promise: api.findCourier({userId: userId,courierNo:courierNo})
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/courier.js